<script>
  import FileDropper from '../crud/file-dropper.svelte';
  import {list} from "../../modules/api-client";

  let files = [];

  async function configure() {
    files = await list('files');
  }

  configure();

  function onError () {
    alert(1)
    console.log(document.getElementsByClassName("file-detail")[0].innerHTML);
    document.getElementsByClassName("file-detail")[0].innerHTML = '<div>Creating preview</div>';
    console.log(document.getElementsByClassName("file-detail")[0].innerHTML);
  }

</script>

<FileDropper>
    <div class="container-fluid">
        <!-- Page Heading -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">Files</h1>
        </div>

        <!-- Content Row -->
        <div class="row">
            <div class="flex-container">
                {#each files as file}
                    <div class="file-detail">
                        <img id="snapshot-image" class="img-fluid shadow rounded" src="{file.thumbnail}" alt="thumbnail"/>
                        <div class="file-info rounded">
                            <div class="row">
                                <div class="title col-12">
                                    {file.name}
                                </div>
                            </div>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </div>
</FileDropper>

<style>

    .flex-container {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
    }
    .file-detail {
        position: relative;
        margin: 1em;
        max-width: 250px;
        height: fit-content;
    }

    .file-info {
        font-size: 0.7em;
        width: 100%;
        background-color: rgba(29, 12, 12, 0.5);
        color: white;
        position: absolute;
        bottom: 0;
    }

    .file-info > div {
        padding: 0.5em;
    }

    .title {
        font-size: 1.2em;
        text-align: center;
        padding: 0.5em;
    }
</style>